import React, { useState } from "react";

const CategoryFilter = ({ categories, selectedCategory, onCategoryChange }) => {
    const [hoveredCategory, setHoveredCategory] = useState(null);
    // Fonction pour obtenir la couleur en fonction de la catégorie
    const getCategoryColor = (category) => {
        const colorMap = {
            "Design Web": "#4A6FFF",
            "SEO": "#FF6B35",
            "Développement Mobile": "#8A4FFF",
            "Innovation": "#00BFB2",
            "E-commerce": "#FF4A6F",
            "Développement Web": "#3772FF",
            "Marketing Digital": "#FF9F1C",
            "Cybersécurité": "#D62828",
            "Transformation Digitale": "#558B6E",
            "Green IT": "#57A773"
        };
        
        return colorMap[category] || "#c14646"; // Couleur par défaut si non trouvée
    };

    return (
        <div className="flex flex-wrap justify-center gap-2 md:gap-3">
            {categories.map(category => {
                const isSelected = category === selectedCategory;
                const categoryColor = category !== "Tous" ? getCategoryColor(category) : "#0ab9ff";
                const isHovered = category === hoveredCategory;
                
                return (
                    <button
                        key={category}
                        onClick={() => onCategoryChange(category)}
                        onMouseEnter={() => setHoveredCategory(category)}
                        onMouseLeave={() => setHoveredCategory(null)}
                        className={`
                            px-4 py-2 rounded-full text-sm transition-all duration-300 font-medium
                        `}
                        style={
                            isSelected || isHovered
                                ? {
                                      backgroundColor: `${categoryColor}20`,
                                      color: categoryColor,
                                  }
                                : {}
                        }
                    >
                        {category}
                    </button>
                );
            })}
        </div>
    );
};

export default CategoryFilter;